import React, { Component } from 'react';
import ReactDropZone from 'react-dropzone';

// react-dropzone's render-prop children are typed to return JSX.Element, but
// callers here return plain strings in some branches (pre-existing behavior).
// Keep the public surface permissive so existing consumers compile unchanged,
// and cast the underlying component so the string-returning render child and
// the legacy activeStyle/rejectStyle props are accepted.
interface DropZoneProps {
    children?: React.ReactNode | ((args: any) => React.ReactNode);
    style?: React.CSSProperties;
    accept?: string;
    onDrop?: (...args: any[]) => void;
    disabled?: boolean;
    [key: string]: any;
}

const ReactDropZoneAny = ReactDropZone as unknown as React.ComponentType<any>;

class DropZone extends Component<DropZoneProps>{
    render(){
        var {children, style, ...other} = this.props;
        var defaultStyle: React.CSSProperties = {
            display: 'flex',
            border: '2px dashed #737373',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '16px',
            flexDirection: 'column',
            boxSizing: 'border-box',
            width: '100%'
        };
        Object.assign(defaultStyle, style);
        var activeStyle: React.CSSProperties = {
            display: 'flex',
            border: '2px solid #ee3224',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '16px',
            flexDirection: 'column',
            boxSizing: 'border-box',
            width: '100%'
        };
        Object.assign(activeStyle, style);
        return <ReactDropZoneAny {...other} style={defaultStyle} activeStyle={activeStyle} rejectStyle={activeStyle}>{children}</ReactDropZoneAny>
    }
}

export default DropZone;
